export const batallesFile = [
    {name: "Bienes de valor", id: 0, joc: 'saga'},
    {name: "Reclamar el territorio", id: 1, joc: 'saga'},
    {name: "Festines y saqueos", id: 2, joc: 'saga'},
    {name: "Una historia de desafíos", id: 3, joc: 'saga'},
    {name: "¡Emboscada!", id: 4, joc: 'saga'},
    {name: "Mantener el botín", id: 5, joc: 'saga'},
    {name: "Desacratización", id: 6, joc: 'saga'},
    {name: "Vieja disputa", id: 7, joc: 'saga'},
    {name: "El cruce", id: 8, joc: 'saga'},
    {name: "Cambio de planes", id: 9, joc: 'saga'},
    {name: "¡Esta es mi tierra!", id: 10, joc: 'clash'},
    {name: "Forrajeo", id: 11, joc: 'clash'},
    {name: "Exploración previa a la batalla", id: 12, joc: 'clash'},
    {name: "Proyección de fuerza", id: 13, joc: 'clash'},
    {name: "Rescate", id: 14, joc: 'clash'},
    {name: "REX", id: 15, joc: 'saga'},
    {name: "Desafio REX", id: 16, joc: 'saga'},
];


